import { Formik } from 'formik';
import { GoMotoComponent, GoMotoFunction } from '../../../../API/GoMoto.types';
import { useCart } from '../../../../context/cart';
import { useKioskLocalization } from '../../../../context/Kiosk/kiosk';
import { useLocalization, useLocalizationExtension } from '../../../../context/Localization/localization';
import { GMAppointmentName } from '../../../../controls/AppointmentName';
import { CTAButton } from '../../../../controls/ButtonBase';
import { GMForm } from '../../../../controls/Form';
import { Heading } from '../../../../controls/Heading/Heading';
import { GMFormTextArea } from '../../../../controls/TextField';
import { nameof } from '../../../../helpers/nameof';
import { PickUpTimeForm, PickUpTimeProps, RequireTransportPickUpTime } from './PickUpTime.types';
import * as Yup from 'yup';
import { LocalizationType } from '../../../../context/Localization/localization.types';

/**
 * This component displays a text area so that the user can inform the dealership
 * when they plan to return to pick up their vehicle.
 *
 * @param onProceed - {@link PickUpTimeProps.onProceed onProceed} description.
 */
export const PickUpTime: GoMotoComponent<PickUpTimeProps> = ({
    onProceed,
}) => {
    const Localization: LocalizationType = useLocalization();
    const { formatRequired } = useLocalizationExtension();
    const { dealer: { vehiclePickupExtraText } } = useKioskLocalization();
    const { transportation: { pickUpTime } } = useCart();

    const initialValues: PickUpTimeForm = {
        pickUpTime: pickUpTime ?? '',
    };

    const onPickupTimeProceed: GoMotoFunction<[RequireTransportPickUpTime], Promise<void>> = async (pickUpTime) => {
        onProceed({ pickUpTime });
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={Yup.object()
                .shape({
                    [nameof<PickUpTimeForm>('pickUpTime')]: Yup.string()
                        .required(formatRequired(Localization.PickupTime))
                        .nullable(),
                })}
            onSubmit={async (values) => {
                onPickupTimeProceed(values.pickUpTime);
            }}
        >
            <GMForm
                heading={
                    <Heading
                        primaryHeading={<GMAppointmentName />}
                        secondaryHeading={Localization.WhenAreYouPickingUp}
                        leftAlign
                    />
                }
                submitButton={
                    <CTAButton
                        styleType={'primary'}
                        type={'submit'}
                        title={Localization.ClickToProceedToNextStep}
                        label={Localization.Proceed}
                        id={Localization.ClickToProceedToNextStep}
                        ariaLabel={Localization.ClickToProceedToNextStep}
                    />
                }
                topDivider
                fullWidthKioskInputs
            >
                {
                    <GMFormTextArea
                        name={nameof<PickUpTimeForm>('pickUpTime')}
                        id={Localization.IPlanOnComingBackIn}
                        title={Localization.IPlanOnComingBackIn}
                        label={''}
                        ariaLabel={Localization.IPlanOnComingBackIn}
                        placeholder={Localization.IPlanOnComingBackIn}
                        autoFocus
                    />
                }
                <div>{vehiclePickupExtraText}</div>
            </GMForm>
        </Formik>
    );
};